import type { Contact } from "./contact";
import type { ClientVehicle } from "./client_vehicle";

/** @deprecated Use tag_ids with OrgTag instead */
export type OrdreTag = "huile" | "diag" | "pieces_en_attente" | "accidente" | "assurance";

export type OrdreStatus =
  | "a_preparer"
  | "devis_initial"
  | "commande"
  | "pret"
  | "reception"
  | "en_cours"
  | "devis_supp"
  | "accord"
  | "acompte"
  | "fin_de_travaux"
  | "facturation"
  | "solde"
  | "solde_paye"
  | "disponible"
  | "restitue";

export type TrackingStep =
  | "carte_grise_manquante"
  | "en_attente_devis"
  | "devis_pret"
  | "en_attente_depot"
  | "vehicule_depose"
  | "devis_supplementaire"
  | "acompte_manquant"
  | "reparations_en_cours"
  | "travaux_termines"
  | "facture_disponible"
  | "solde_en_attente"
  | "paiement_valide"
  | "vehicule_disponible"
  | "vehicule_restitue";

export type OrdreFlag = "bloque" | "urgent";

export const ORDRE_FLAG_CONFIG: Record<OrdreFlag, { label: string; color: string; bg: string; icon: string }> = {
  bloque: { label: "Bloqué", color: "#DC2626", bg: "#FEE2E2", icon: "warning" },
  urgent: { label: "Urgent", color: "#D97706", bg: "#FEF3C7", icon: "flag" },
};

export interface OrdreIntervention {
  id: string;
  label: string;
  default_hours: number;
  estimated_hours: number;
  assigned_to?: string;
  group?: string; // "initial" | "additional_0" | "additional_1" | ...
}

export interface InterventionGroupStatus {
  status: "draft" | "devis_sent" | "devis_signed" | "ready";
  extraction_id?: string;
  devis_token?: string;
}

export interface OrdreDocument {
  id: string;
  name: string;
  type: string;
  gcs_path?: string;
  created_at: string;
}

export interface OrdreTimelineEvent {
  id: string;
  date: string;
  user_name: string;
  user_color: string;
  action: string;
  type: "documents" | "photos" | "status_change" | "comment";
  document_names?: string[];
  photo_urls?: string[];
  status_label?: string;
  status_type?: "success" | "warning" | "info";
  ordre_ref?: string;
}

export interface Ordre {
  id: string;
  org_id: string;
  dossier_id?: string;
  vehicle_id?: string;
  contact_ids?: string[];
  num: string;
  name: string;
  tags: OrdreTag[];
  tag_ids?: string[];
  status: OrdreStatus;
  restitution?: { seconds: number; nanoseconds?: number };
  reception_date?: { seconds: number; nanoseconds?: number };
  modele?: string;
  immatriculation?: string;
  campagne?: string;
  recall_campaigns?: { code: string; libelle: string; status: string }[];
  assigned_to?: string;
  mobility_option?: string;
  rental_vehicle_id?: string;
  rental_reservation_id?: string;
  created_at: { seconds: number; nanoseconds?: number };
  notes?: string;
  vehicle?: ClientVehicle;
  contacts?: Contact[];
  interventions: OrdreIntervention[];
  documents?: OrdreDocument[];
  timeline?: OrdreTimelineEvent[];
  discussion_id?: string;
  internal_discussion_id?: string;
  tracking_step?: TrackingStep;
  devis_sign_token?: string;
  devis_sign_status?: string;
  devis_document_id?: string;
  devis_signer_name?: string;
  devis_signer_email?: string;
  client_rating?: number;
  client_rating_date?: string;
  amount?: number;
  labor_cost?: number;
  parts_cost?: number;
  devis_requested?: boolean;
  devis_signed?: boolean;
  acompte_requested?: boolean;
  acompte_paid?: boolean;
  solde_requested?: boolean;
  solde_paid?: boolean;
  intervention_groups?: Record<string, InterventionGroupStatus>;
  flags?: OrdreFlag[];
  flag_reason?: string;

  or_number?: string;
  servicebox_rdv_id?: string;
  servicebox_dossier_id?: string;
  /** OR number returned by Alpha DMS after transferring a signed devis. Set once the proxy successfully transfers the dossier. */
  alpha_or_number?: string;
  alpha_transferred_at?: string;
  booking_request?: {
    service?: string;
    intervention_type?: string;
    intervention?: string;
    mobility?: string;
    tire_option?: string;
    deposit_date?: string;
    deposit_time?: string;
    restitution_date?: string;
    restitution_time?: string;
    immatriculation?: string;
    km?: string;
    comments?: string;
    channel?: string;
    civilite?: string;
    nom?: string;
    prenom?: string;
    phone?: string;
    email?: string;
    code_postal?: string;
  };
}

/* LEGACY — removed from Ordre, managed separately
export interface OrdreContact {
  id: string;
  name: string;
  role: string;
  phone?: string;
  email?: string;
}

export interface OrdreVehicle {
  id: string;
  plate: string;
  marque?: string;
  modele?: string;
  coloris?: string;
  km?: number;
  vin?: string;
}

export interface OrdreAtelierCharge {
  id: string;
  worker_name: string;
  specialty: string;
  date: string;
  start_hour: number;
  duration_hours: number;
}
*/
